﻿// @ts-ignore
import GLightbox from 'glightbox';

// @ts-ignore
import './glightbox.utils.css';

const lightbox = GLightbox({});

export function openGallery() {
    lightbox.open();
}
